import React from 'react';
import styled from 'styled-components';
import { IconWarning } from '@commoncomponents/frontend-components/dist/components/Icons/Icons';
import { colors } from '@commoncomponents/frontend-components/dist/styled';
import StandardInput from '../StandardInput';
import StandardLabel from '../StandardLabel';
import ErrorMessage from '../ErrorMessage';
import { VisibilityOff, VisibilityOn } from '../Icons';
const Styles = styled.div `
  display: flex;
  flex-direction: column;
  ${(props) => props.password && 'position: relative;'}
`;
const IconWrapper = styled.div `
  position: absolute;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 45px;
  width: 45px;
  @media ${(props) => props.theme.md} {
    height: 36px;
  }
`;
const BottomInfoWrapper = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
  &.single-child {
    justify-content: flex-end;
  }
`;
const WarningMessage = styled.div `
  align-items: center;
  color: ${colors.touchyLemon};
  display: flex;
  font-size: 14px;
  line-height: 22px;
  margin: 8px 0;

  svg {
    margin-right: 6px;
  }
`;
const UsedCharsLabel = styled.div `
  font-size: 12px;
`;
const StandardInputWithLabel = ({ required, label, className, inputProps, error, errorProps, labelProps, showPassword, handleTogglePassword, password, showAvailableChars, maxLength, tooltip, warning, autoFilled, }) => {
    const value = inputProps && inputProps.value;
    return (React.createElement(Styles, { className: className, password: password },
        password && (React.createElement(IconWrapper, { onClick: () => handleTogglePassword(!showPassword) }, showPassword ? React.createElement(VisibilityOn, null) : React.createElement(VisibilityOff, null))),
        label && (React.createElement(StandardLabel, { required: required, labelProps: labelProps, text: label, tooltip: tooltip })),
        React.createElement(StandardInput, Object.assign({ maxLength: maxLength, required: required, autoFilled: autoFilled }, inputProps)),
        React.createElement(BottomInfoWrapper, { className: error || warning ? '' : 'single-child' },
            error && (React.createElement(ErrorMessage, Object.assign({ className: "code-error", message: error }, errorProps))),
            warning && (React.createElement(WarningMessage, null,
                React.createElement(IconWarning, { color: colors.touchyLemon }),
                warning)),
            showAvailableChars && (React.createElement(UsedCharsLabel, null, `${value.length}/${inputProps.maxLength}`)))));
};
StandardInputWithLabel.defaultProps = {
    errorProps: null,
    error: null,
    required: false,
    labelProps: null,
    className: '',
    label: null,
    password: false,
    showAvailableChars: false,
};
export default StandardInputWithLabel;
